module.exports = __webpack_public_path__ + "img/crc-05.df2ed28a.jpg";